import { Box } from '@chakra-ui/react';
import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

type SortableProps<T> = {
  children?: React.ReactNode;
  item: T;
  onHover?: (draggedItem: T, hoveredItem: T) => void;
  onDrop?: (item: T) => void;
  width?: string;
};

export const Sortable = <T extends { id: string; type: string }>({
  children,
  onHover,
  item,
  onDrop,
  width = '100%',
}: SortableProps<T>) => {
  const ref = useRef(null);

  const [, drop] = useDrop(() => ({
    accept: item.type,
    drop(itemDropped: T, monitor) {
      if (monitor.isOver() && onDrop) {
        onDrop(itemDropped);
      }
    },
    hover(itemDragged: T, monitor) {
      if (itemDragged.id !== item.id && monitor.isOver() && onHover) {
        onHover(itemDragged, item);
      }
    },
  }));

  const [{ isDragging }, drag] = useDrag(() => ({
    type: item.type,
    item,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    isDragging: (monitor) => monitor.getItem().id === item.id,
  }));

  drag(ref);
  drop(ref);

  return (
    <Box
      style={{
        borderRadius: 'var(--border-radius)',
        backgroundColor: isDragging
          ? 'var(--bgCompSecondaryTiny)'
          : 'transparent',
      }}
      // transform="translate3d(0,0,0)"
    >
      <div
        ref={ref}
        style={{
          cursor: 'move',
          width,
          opacity: isDragging ? 0 : 1,
        }}
      >
        {children}
      </div>
    </Box>
  );
};
